import React from 'react';
import { Col, FormGroup, Input, Label, Row } from '../../../components/Bootstrap';
import './ReportTopRow.scss';
const Download = require('./download.svg');

interface ReportTopRowProps {
  reportType: string;
  fetchCheckedReport();
  onChangeSection(type: string);
  showDisbursementOption: boolean;
}

export class ReportTopRow extends React.Component<ReportTopRowProps> {
  public render() {
    return (
      <Row className='mb-4'>
        <Col md={4}>
          <FormGroup className='noble-custom-select report-picker'>
            <Label>Report Type</Label>
            <Input value={this.props.reportType} onChange={this.props.onChangeSection} type='select'>
              {this.props.showDisbursementOption && <option value='disbursements'>Disbursement</option>}
              <option value='sessions'>Session</option>
            </Input>
          </FormGroup>
        </Col>
        <Col className='d-none d-md-block'>
          <div className='d-flex justify-content-end align-items-end h-100'>
            <img onClick={this.props.fetchCheckedReport} src={Download} width='35px' />
          </div>
        </Col>
      </Row>
    );
  }
}
